import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    this.autogrow = this.autogrow.bind(this)
  }

  connect() {
    this.element.style.overflow = "hidden"

    this.autogrow()

    this.element.addEventListener("input", this.autogrow)
    window.addEventListener("resize", this.autogrow)
  }

  disconnect() {
    this.element.removeEventListener("input", this.autogrow)
    window.removeEventListener("resize", this.autogrow)
  }

  autogrow() {
    this.element.style.height = "auto" // Force re-print before calculating the scrollHeight value.
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
